module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-drawer pr4"
  }, [(_vm.livre) ? [_c('header', {
    staticClass: "header"
  }, [_c('cover-book', {
    staticClass: "cover",
    attrs: {
      "cover": _vm.livre && _vm.livre.couverture
    }
  }), _c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.livre.titre))]), _c('h6', {
    staticClass: "subtitle auteurs"
  }, [_c('b', [_vm._v(_vm._s(_vm.auteurs))])])])], 1), _c('div', {
    staticClass: "desc content f5 lh-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.livre.description)
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1086e2e2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/presentation/book-drawer.vue
// module id = 1355
// module chunks = 1